import { Injectable } from '@angular/core';
import { EnvironmentService } from '@methylium/core';
import { HubService } from './hub.service';

@Injectable()
export class DeviceTaskManagementHubService extends HubService {
  constructor(environmentService: EnvironmentService) {
    super(`${environmentService.environment.devicetaskmanagement.api as string}/hubs/device-task-management`);
  }
}
